import axios from "axios";
import Qs from 'qs';
import cryptoJs from "@/common/encryption";

const enterpriseInstance = axios.create({
    // baseURL:'http://192.168.0.173:28099',
    baseURL: "https://bccapi.bangqichat.com",
});
// 配置拦截器
enterpriseInstance.interceptors.request.use(async (config) => {
    // 批量处理post请求
    if (config.data) {
        if (config.method === "post" && config.data.request == "form") {
            config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
            config.data = Qs.stringify(config.data);
        }
    } else if (config.method === "post") {
        config.data = {}
    }
    if (localStorage.getItem('token')) {
        config.headers['token'] = localStorage.getItem('token');
    }
    /*允许所有来源访问 */
    config.headers['Access-Control-Allow-Origin'] = '*';
    /*这个属性主要是设置浏览器优先使用什么模式来渲染页面的。代码IE=edge告诉IE使用最新的引擎渲染网页,这个在需要兼容IE浏览器的情况下都可以加上这句话*/
    config.headers['http-equiv'] = 'X-UA-Compatible';
    config.headers['content'] = 'IE=EDGE';
    return config;
}), (err) => {
    return Promise.reject(err);
};
// 响应拦截器
enterpriseInstance.interceptors.response.use((res) => {
        if (res.data.code == 403) {
            history.go(-1);
            return Promise.reject(res.data);
        } else if (res.data.code == 200) {
            let reg = new RegExp('https', 'g')//g代表全部
            if (res.data.encryption) {
                res.data.content = JSON.parse(cryptoJs.jiemi(res.data.content));
            }
        }
        return res.data;
    }, (err) => {
        console.log("服务器错误！");
        return Promise.reject(err);
    }
);
export default enterpriseInstance;